export const tableConfig = {
  columnSearchKeys: {
    globalQuery: "",
    date: {
      value: "",
      column: ["for_date"]
    },
    period: {
      value: "",
      column: ["period.name"],
      sortBy: "period.name"
    },
    from: {
      value: "",
      column: ["from.name"],
      sortBy: "from.name"
    },
    to: {
      value: "",
      column: ["to.name", "to.first_name", "to.last_name"],
      sortBy: "to.name"
    },
    confirm_cancel: {
      value: "",
      column: ["confirm_cancel"]
    },
    comments: {
      value: "",
      column: ["latest_comment.comment"]
    }
  },
  dataTableFields: [
    {
      key: "for_date",
      label: "common.date",
      type: "pass-view",
      _style: "min-width:140px"
    },
    {
      key: "string_status",
      label: "common.status",
      _style: "min-width:150px",
      type: "pass-view"
    },
    {
      key: "period",
      label: "common.period",
      _style: "min-width:150px",
      type: "pass-view"
    },
    {
      key: "from",
      label: "common.from",
      type: "pass-view"
    },
    {
      key: "to",
      label: "common.to",
      type: "pass-view"
    },
    {
      key: "confirm_cancel",
      label: "appointment_pass.confirmed_canceled",
      type: "pass-view",
      _style: "min-width:180px"
    },
    {
      key: "actions",
      label: "common.actions",
      _style: "min-width:150px"
    },
    {
      key: "comments",
      label: "common.comments",
      type: "pass-view",
      _style: "min-width:150px"
    }
  ]
}
export default tableConfig
